import axios from "axios";
import LocalStorageService from "./LocalStorageService";
import { authorizationStore } from "./authorizationStore";
import webAppConfig from "../commons/webApp.config";

const requestConfig = {
  baseURL: webAppConfig.baseURL,
};

function getClient() {
  let client = axios.create({
      ...requestConfig,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + LocalStorageService.getAccessToken(),
      }
  });

  client.interceptors.response.use((response) => {
    return response;
  }, function (error) {
      const originalRequest = error.config;
      if (error.response && error.response.status === 401 && !originalRequest._retry) {
          let localStorage = LocalStorageService;
          originalRequest._retry = true;
          const config = {
            ...requestConfig,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          };
          const data = `grant_type=refresh_token&refresh_token=${localStorage.getRefreshToken()}`;
          return axios.post('/token', data, config)
            .then(res => {
              if (res.status === 200) {
                localStorage.setToken(res.data);
                client.defaults.headers['Authorization'] = 'Bearer ' + localStorage.getAccessToken();
                originalRequest.headers['Authorization'] = 'Bearer ' + localStorage.getAccessToken();
                return axios(originalRequest);
              }
            })
            .catch(err => {
              console.error(['Authorization:Interceptor'], err);
              authorizationStore.dispatch('logout');
            });
      } else if (error.response && error.response.status === 401) {
        authorizationStore.dispatch('logout');
      } else {
        console.error(['Authorization:Interceptor'], error);
      }
      return Promise.reject(error);
  });
  return client;
}

export const commonStore = {
  state: {
    client: getClient(),
  },
  actions: {
    async setClientWorkspace({ state }, payload) {
      state.client.headers['workspace'] = payload;
    }
  },
}